// import { CustomLoadingCellRendererProps } from 'ag-grid-react';
import React from 'react';

export default (props: any & { loadingMessage: string }) => {
    return (
        <div className="ag-custom-loading-cell" style={{ paddingLeft: '10px', lineHeight: '25px' }}>
            <i className="fas fa-spinner fa-pulse"></i> <span> {props.loadingMessage}</span>
        </div>
    );
};